import * as React from 'react';

export interface Expanded {
  [key: string]: boolean;
}

interface AccordionContextType {
  expanded: Expanded;
  toggle: (name: string, isExpanded: boolean) => void;
}

const AccordionContext = React.createContext<AccordionContextType>({
  expanded: {},
  toggle: () => {},
});

export default AccordionContext;
